import { useRouteLoaderData } from 'react-router';

import { LAYOUT_ROUTE_ID } from '~/lib/meta';
import type { loader } from '~/routes/layout';

export type LayoutData = Awaited<ReturnType<typeof loader>>;

/**
 * The layout loader's states and sites, from any component under the marketing
 * layout. Its own module, importing the loader as a type only, so components never
 * pull the layout route (and its server imports) into the client bundle.
 */
export function useLayoutData(): LayoutData {
  return useRouteLoaderData<typeof loader>(LAYOUT_ROUTE_ID) ?? { states: [], sites: [] };
}
